export default "__VITE_ASSET__DkAEHalI__"